import React from 'react'

export const SelectHome = () => {
  return (
    <div>Select</div>
  )
}

